import SunSpinner from "./SunSpinner";

export const StandardSunSpinner = () => {
    return <SunSpinner horizontalCentered height="40px" width="40px" />;
};
